import React from "react";

import { Collapse } from "@blueprintjs/core";
import { IViewProps, View } from "core/decorators/View";
import AccordionViewConfig from "./AccordionViewConfig";


export enum AccordionVariant {
	DEFAULT = "default"
}

interface IAccordionItemArgs {
	isExpanded: boolean;
	toggleExpand: () => void;
}

interface IAccordionViewProps<T> extends IViewProps<AccordionViewConfig> {
	items: T[];
	getId: (item: T, index: number) => string | number;
	renderItem: (item: T, index: number, args: IAccordionItemArgs) => JSX.Element;
	renderExpand: (item: T, index: number, args: IAccordionItemArgs) => JSX.Element;
}

interface IAccordionViewState {
	expanded: {
		[id: string]: boolean;
	};
}

@View({
	id: 'accordion',
	configClass: AccordionViewConfig,
	variants: AccordionVariant
})
export class AccordionView<T> extends React.Component<IAccordionViewProps<T>, IAccordionViewState> {

	public state = { expanded: { } };

	public render() {
		const { items } = this.props;

		return (
			<div>
				{items && items.map(this.renderItem)}
			</div>
		);
	}

	private renderItem = (item: T, index: number) => {
		const { getId, renderItem, renderExpand } = this.props;

		const id = getId(item, index);

		const args = {
			isExpanded: this.state.expanded[id],
			toggleExpand: this.toggleExpand(id)
		};

		return (
			<div key={id}>
				<div onClick={this.toggleExpand(id)}>
					{renderItem(item, index, args)}
				</div>
				<Collapse isOpen={this.state.expanded[id]}>
					<div>
						{renderExpand(item, index, args)}
					</div>
				</Collapse>
			</div>
		);
	}

	private toggleExpand = (id: any) => () => this.setState({
		expanded: {...this.state.expanded, [id]: !this.state.expanded[id]}
	})
}



// WEBPACK FOOTER //
// ./src/common/views/accordion/Accordion.view.tsx